var _defs, _path, _rect, _path2, _path3, _rect2, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _circle4, _path9, _line, _line2, _path10, _path11, _circle5, _path12, _line3, _line4, _line5, _path13, _path14, _line6, _polygon, _path15, _polygon2, _path16, _path17, _path18, _path19, _path20, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartCandidate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-dasharray:2.39 3.98;}.cls-2{fill:#fff;}.cls-4{fill:#0b1320;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.27,136.64c-21.12-1.49-33.31-30-22.52-45.92"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.64,
    y: 190.05,
    width: 41.92,
    height: 13.89
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.61,217.12V87.19c0-3.78,2.77-6.84,6.19-6.84H243.33c3.42,0,6.19,3.06,6.19,6.84V217.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.14,204.17v6.19H135v-6.19H45.23v7.06a6.19,6.19,0,0,0,6.19,6.19H258.81a6.19,6.19,0,0,0,6.19-6.19v-7.06Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.95,
    y: 55.59,
    width: 105.24,
    height: 173.34,
    transform: "translate(295.83 -11.31) rotate(90)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 130.13,
    cy: 139.87,
    r: 21.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 197.97,
    cy: 139.87,
    r: 21.17
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.28,
    cy: 139.87,
    r: 21.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.92,147.65h-2c-.6,0-.89-.68-.88-1.28v-4.8s-.16-.26-.12-.26h3a1.67,1.67,0,0,1,1.45,1.81v2.74A1.66,1.66,0,0,1,121.92,147.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.75,141.35h1.2a2.28,2.28,0,0,1,2.28,2.28v1.9a2.17,2.17,0,0,1-2.17,2.17H136.8a.33.33,0,0,1-.33-.33v-4.73A1.29,1.29,0,0,1,137.75,141.35Z",
    transform: "translate(277.28 289.44) rotate(-179.84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.43,141.41l0,5a1.19,1.19,0,0,1-1.21,1.08h-2a1.53,1.53,0,0,1-1.51-1.63v-2.71a1.54,1.54,0,0,1,1.53-1.61h3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119,141.49h2.92a1.65,1.65,0,0,1,1.64,1.62v2.71a1.64,1.64,0,0,1-1.65,1.62h-2a1.09,1.09,0,0,1-1.08-1.09v-4.75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.75,147.5a10.87,10.87,0,0,1-9.18,5.39"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 130.57,
    cy: 152.89,
    r: 1.53
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.43,141.68v-5.42c0-5.78-5-10.49-11.27-10.51h0c-6.24,0-11.32,4.66-11.33,10.45l0,5.41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.8,
    y1: 139.87,
    x2: 105.61,
    y2: 139.87
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.59,
    y1: 139.87,
    x2: 174.41,
    y2: 139.87
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.06,52.58H36.6a4.51,4.51,0,0,1,4.51,4.51V70.64A18.06,18.06,0,0,1,23.06,88.69h0A18.06,18.06,0,0,1,5,70.64v0A18.06,18.06,0,0,1,23.06,52.58Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.06,79.66a9,9,0,0,0,7.83-4.53,9,9,0,0,0-7.81-4.49h0a9,9,0,0,0-7.83,4.53A9,9,0,0,0,23.06,79.66Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.03,
    cy: 65.16,
    r: 3.56
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201,139.93l4.7,4.7a1.33,1.33,0,0,1-1.88,1.88l1.26,1.26a1.33,1.33,0,1,1-1.89,1.88l-.62-.63a1.33,1.33,0,1,1-1.89,1.88l-.62-.63a1.33,1.33,0,0,1-1.88,1.89l-7.55-7.54c-2.21-2.22-1.07-5.06-2.4-6.39"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.1,
    y1: 141.81,
    x2: 203.8,
    y2: 146.51
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 197.53,
    y1: 144,
    x2: 202.55,
    y2: 149.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 195.96,
    y1: 146.2,
    x2: 200.04,
    y2: 150.27
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.74,143.69l1.48-1.48c1.25-1.25.78-4.22,2-5.47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.31,131.06l-1.25,1.26c-1.25,1.25-2.51,0-3.76,1.25l-4.79,4.79a.45.45,0,0,0,0,.63l.31.31a1.78,1.78,0,0,0,2.51,0l2.51-2.51a4.45,4.45,0,0,0,6.28,0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 195.96,
    y1: 134.91,
    x2: 193.71,
    y2: 132.66
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.54 127.41 201.62 130.51 209.16 138.05 212.11 134.91 204.54 127.41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.8,143.58l-1.37,1.36a1.28,1.28,0,0,0,.32,1.57,1.32,1.32,0,0,0,1.57.32l-.32.31a1.33,1.33,0,0,0,1.88,1.88l.32-.31a1.33,1.33,0,1,0,1.88,1.88h0a1.29,1.29,0,0,0,.31,1.57,1.33,1.33,0,0,0,1.57.31l1.25-1.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "183.82 136.4 186.78 139.54 194.32 132 191.4 128.9 183.82 136.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.51,132.11a.62.62,0,0,1,.62-.63.63.63,0,0,1,0,1.25A.62.62,0,0,1,190.51,132.11Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.21,130.44a.63.63,0,0,1,1.25,0,.63.63,0,0,1-1.25,0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.62,143.86a3.65,3.65,0,1,1,3.65-3.65A3.64,3.64,0,0,1,53.62,143.86Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.89,152.83a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,68.89,152.83Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.89,134.2a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,68.89,134.2Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.54,
    y1: 138.05,
    x2: 65.68,
    y2: 132.27
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.54,
    y1: 142.38,
    x2: 65.68,
    y2: 147.48
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCandidate);
export default __webpack_public_path__ + "static/media/smart_candidate.81383c754bfc57587febd527d6eec972.svg";
export { ForwardRef as ReactComponent };